import {Pipe, PipeTransform} from "@angular/core";

@Pipe({ name: 'getLogoPath' })
export class GetLogoPathPipe implements PipeTransform {
  transform(fileName: string ) {
    return `assets/img/consumers/portals/${fileName}`;
  }
}
